import React, { useEffect, useRef, useState } from 'react';
import useSeo from '../hooks/useSeo';
import useReveal from '../motion/useReveal';
import Hero from '../sections/home/Hero';
import Manifesto from '../sections/home/Manifesto';
import Capabilities from '../sections/home/Capabilities';
import WorkReel from '../sections/home/WorkReel';
import OwnProducts from '../sections/home/OwnProducts';
import Process from '../sections/home/Process';
import DashboardFeatures from '../sections/home/DashboardFeatures';
import PricingTeaser from '../sections/home/PricingTeaser';
import IndustriesTeaser from '../sections/home/IndustriesTeaser';
import FinalCTA from '../sections/home/FinalCTA';
import useSiteCheck from '../features/siteCheck/useSiteCheck';
import SiteCheckReport from '../features/siteCheck/SiteCheckReport';
import { fetchIndustries } from '../features/siteCheck/api';

export default function HomePage() {
  useSeo({
    title: 'Websites, SEO, AI, API Integrations, AGI Bots & Travel Tech',
    description: 'Bluprise builds Websites, SEO, AI, API Integrations, AGI Bots and Travel Tech. We also build and run our own products, including BluBeds, our hotel booking platform.',
    path: '/',
  });
  const scope = useReveal();
  const siteCheck = useSiteCheck();
  const [industries, setIndustries] = useState([]);
  const reportRef = useRef(null);

  useEffect(() => {
    let alive = true;
    fetchIndustries().then((list) => { if (alive) setIndustries(list); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (siteCheck.phase !== 'done' || !reportRef.current) return;
    const smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    reportRef.current.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }, [siteCheck.phase]);

  return (
    <div ref={scope} className="reveal-scope">
      <Hero siteCheck={siteCheck} industries={industries} />
      {siteCheck.phase === 'done' && siteCheck.check ? (
        <div ref={reportRef} id="site-check-report" className="scroll-mt-24">
          <div className="container-x">
            <SiteCheckReport check={siteCheck.check} industries={industries} onUnlock={siteCheck.unlock} unlocking={siteCheck.unlocking} unlockError={siteCheck.unlockError} />
          </div>
        </div>
      ) : null}
      <Manifesto />
      <Capabilities />
      <WorkReel />
      <OwnProducts />
      <Process />
      <DashboardFeatures limit={6} showDashboard lede="Every project gets this hub on day one. Click around, it runs on sample data." />
      <PricingTeaser />
      <IndustriesTeaser />
      <FinalCTA />
    </div>
  );
}
